export default "__VITE_ASSET__Cci9949D__"